<template>
    <div> NOAA Bu kısım iptal</div>
</template>

<script>
    export default {
        name: "NOAA"
    }
</script>

<style scoped>

</style>
